import React from 'react';
import {wdiCore} from '@/components/WdiControls';
import { Input, Popover,} from 'antd';



export type OaProgramSelectProps = {
  value?: API.OaProgramVo[];
  onChange?: (value?: API.OaProgramVo[]) => void;
};

export const OaProgramViewApp: React.FC<OaProgramSelectProps> = (props) => {

  return (
    <>
      <Popover
        content={<>
          {props.value?.map(item => {
            return <a
              style={{display: 'block',color: '#2299ee'}}
              onClick={() => window.open(item.url)}
            >
              {wdiCore.String.Join(item.documentNumber, item.note)}
            </a>
          })}
        </>}
      >
        <Input
          style={{color: '#2299ee',cursor: 'pointer'}}
          readOnly
          placeholder={"请选择OA单号"}
          value={props.value?.map(item => wdiCore.String.Join(item.documentNumber, item.note)).join()}
          onClick={()=>{
            const url = props.value?.[0]?.url;
            if(url){
              window.open(url);
            }
          }}
        />
      </Popover>
    </>
  );
}

